module.exports = __webpack_public_path__ + "img/other1.5b60d56a.png";